import type { PaymentIntentResponse } from '@nestjs-boilerplate/types';
import { useMutation } from '@tanstack/react-query';
import { createPaymentIntent } from '../api/payments';

/**
 * Hook for creating a Stripe PaymentIntent.
 * Returns a mutation function to create the payment intent on demand.
 */
export function useCreatePaymentIntent() {
  return useMutation<PaymentIntentResponse, Error, number>({
    mutationFn: (amountPence: number) => createPaymentIntent(amountPence),
  });
}
